module.exports = __webpack_public_path__ + "static/eventx-banner-9e0b7ebfccf90b25c7ab14bc40a130c3.webm";